import { CenterFocusStrong } from "@material-ui/icons";

import CommonStyles from "../../styles/CommonStyles.css";
import PreviewStyles from "../../styles/PreviewStyles.css";

export const styles = (theme) => ({
...CommonStyles,
...PreviewStyles,
  selected: {
    color: "#fff",
    marginLeft:"0",
    padding:"0",
    "& a":{
      color:"#fff",
      fontWeight:"bold",
      background: "#515151 !important",
      borderLeft:"5px solid #0c853e !important"
    }
  },
  userLanguage:{
    padding:"0px",
    "& .MuiSelect-select":{
      padding:"10px 70px 10px 10px",
    },
  },
  notSelected: {},
  imglogo: {
    width: "45px",
    verticalAlign: "middle",
    marginRight: "14px",
    padding: "8px",
  },
  headingTxt: {
    position: "absolute",
    left: "-100000px",
  },
  player: {
    background: "#181818",
    padding: "0",
    "& div": {
      margin: "0 !important",
    },
  },
  trackName: {
    fontSize: "12px",
    textAlign: "center",
    color: "#00d056",
  },
  bbclogo: {
    marginTop: "15px",
    textAlign: "center",
    marginRight: "20px",
    borderRadius: "0",
    width: "100px !important",
    "& div": {
      width: "100px !important",
    },
  },
  square: {

    display: "flex",
    borderRadius: "3px",
    alignItems: "center",
    margin:"0 15px 0 25px",
    textAlign:"left",
  },
  userOrganization:{
     fontSize:"0.8em",
  },
  userSquareImage:{
    width: "80px !important",
    display: "flex",
    borderRadius: "3px",
    alignItems: "center",
    margin:"0 auto",
    "& img":{
      color: "transparent",
      width: "80%",
      height: "auto",
    }
  },
  langArea: {
    borderRadius: "5px",
    background: "#464646",
    height: "20px",

    textAlign: "center",
    padding: "10px",
    verticalAlign: "middle",

    textAlign: "center",
    display: "flex",
    alignItems: "center",
    "& > div": {
      borderRadius: "3px",
      width: "auto",
      display: "inline-block",
      padding: " 0 10px",
      fontSize: "12px",
    },
  },
  userArea: {
    padding: "5px 10px 5px 0px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    "& div":{
      textAlign:"left",
    }
  },
  userMainWrap:{
    textAlign:"right",
    display:"flex",
    float: "right",
    marginTop: "0px",
    alignItems: "center"
  },
  userRole:{
    fontSize:"0.7em",
    color:"#999",
    display:" block",   
    maxWidth: "65px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  firstName:{
    display: "block",
    overflow: "hidden",
    maxWidth: "65px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  userIcon: {
    color: "#b9b9b9 !important",
    verticalAlign: "middle",
    marginRight: "10px",
    borderRadius: "150px !important",
  },
  headerTools: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonSquare: {
    borderRadius: "0 !important",
    justifyContent: "center",
    marginRight: "15px",
    display: "flex",
    "& button": {
      borderRadius: "5px !important",
      fontSize: "15px",
      padding: "0 0 0 8px !important",
      border:"1px solid #464646"
    },
  },
  userWorkspaceImage:{
    width: "100px",
    marginRight: "10px",
    borderRadius: "3px",
  },
  panelWidth: {
    // width: "440px",
    padding: "20px",
    textAlign: "center",
  },
  userEdit: {
    margin: "15px auto",
    display: "block",
    width: "140px",
    position:"relative",
  },
  editIcon:{
    position:"absolute",
    top:"4px",
    right:"18px",
    background:"#0C853E",
    "& button":{
    position:"absolute",
    top:"0",
    right: "0px",
    background: "#000",
    color:" #fff",
    borderRadius: "5px !important",
    minWidth: "inherit  !important",
    width: "30px !important",
    height: "30px  !important",
    "&:hover":{
      backgroundColor: "#000",
    },
    },    
    "& svg":{
    color:" #fff",
    fontSize:"15px",
    },
  },
deleteIcon:{
    position:"absolute",
    top:"30px",
    right: "0",
    background:"#0C853E",
    "& button":{
    position:"absolute",
    top:"0",
    right: "0px",
    background: "#000",
    color:" #fff",
    "&:hover":{
      backgroundColor: "#000",
    }
    },
    "& svg":{
    color:" #fff",
    fontSize:"15px",
    },
  },


  userSignOut:{
    "& button":{
    textAlign:"center",
    display: "inline-block",
    background: "#0C853E",
    borderRadius: "3px",
    border:"1px solid #0C853E",
    color:"#fff",
    padding: "8px 15px",
    fontSize: "11px",
    marginBottom: "10px",
    textDecoration:"none",  
    fontWeight: "400",
    "&:hover":{
      border:"1px solid #000",
      background: "#000",
      color:"#29D211",
      textDecoration:"none !important",  
    },
  }
  },
  viewUser: {
    width: "140px",
    height: "140px",
    borderRadius: "150px !important",
  },
  muDetailWrap: {
    display: "flex",
    padding: "8px 0",
    borderBottom: "1px solid #525252",
  },
  
  mainListWrap:{
    textAlign:"left"
  },
  usersHelpButton:{
    "& .MuiSvgIcon-root":{
      fontSize: "1.6em",
    },
    "& > button":{
      width: "38px",
      height: "38px",
      margin: "0 0 0 10px",
    } ,
    "& .MuiButton-root":{
      color:"#04ad49"
    }
   },
   usersMessageButton:{
    "& > button":{
      width: "38px",
      height:"38px",
      minWidth:"inherit",
      padding:"5px",
     marginLeft: "10px",
      background: "#008135",
      "&:hover":{
        background: "#04923F",
      }
    }  
   },
   helpDrawer:{
     zIndex:"1299"
   },
   orgDetails:{
    display:"block",
    marginTop:"20px",
    "& .MuiAvatar-square":{
      background:"none",
    }
   },
   orgListItems:{
    "& a":{
      display:"flex",
      alignItems:"center",
      background:"#333131",
      color:"#fff",
      borderRadius:"4px",
      width: "100%",
      padding:"5px 10px",
      borderLeft:"5px solid #333131",
      "&:hover":{
        borderLeft:"5px solid #0c853e",
      }
    },
    "& .MuiMenuItem-root":{
      padding:"0",
      marginBottom:"10px",
      "&:hover":{
      borderRadius:"4px",
    }
    }
   }, 
   orgListName:{
    fontSize:"13px",
    textTransform:"none",
    color:"#fff",
    borderBottom: "1px solid #595959",
    display: "block",
    width: "100%",
    marginBottom: "10px",
    paddingBottom: "10px",
   }
});
